export const ArmRecovery =
{
    title: 'Arm Recovery',
    categories: ['Total Strength', 'IR', 'ER', 'Scaption', 'Grip'],
    zones: {
        normal: {
            totalStrength: '> -10',
            iR: '> -5',
            eR: '> -5',
            scaption: '> -5',
            grip: '> -5',
        },
        watch: {
            totalStrength: '-10',
            iR: '-5',
            eR: '-5',
            scaption: '-5',
            grip: '-5',
        },
        warning: {
            totalStrength: '-20',
            iR: '-8',
            eR: '-8',
            scaption: '-8',
            grip: '-8',
        },
        medical: {
            totalStrength: '< -25',
            iR: '< -12',
            eR: '< -12',
            scaption: '< -12',
            grip: '< -12',
        }
    }
}
export const ArmFatigue =
{
    title: '% Fresh',
    zones: {
        normal: {
            freshP: '> 0.90',
        },
        watch: {
            freshP: '0.90 to 0.80',
        },
        warning: {
            freshP: '< 0.80',
        }
    }
}
export const ArmReadiness =
{
    title: 'Arm Readiness',
    categories: ['Total Primer', 'Accel', 'Decel'],
    zones: {
        normal: {
            totalPrimer: '> -10',
            accel: '> -5',
            decel: '> -5',
        },
        watch: {
            totalPrimer: '-10',
            accel: '-5',
            decel: '-5',
        },
        warning: {
            totalPrimer: '-20',
            accel: '-8',
            decel: '-8',
        },
        medical: {
            totalPrimer: '< -25',
            accel: '< -12',
            decel: '< -12',
        }
    }
}
export const ArmStrength =
{
    title: 'Arm Strength',
    categories: ['Total Strength', 'IR', 'ER', 'Scaption', 'Grip'],
    zones: {
        normal: {
            totalStrength: '> 70%',
            iR: '> 20%',
            eR: '> 20%',
            scaption: '> 15%',
            grip: '> 15%',
        },
        watch: {
            totalStrength: '70%',
            iR: '20%',
            eR: '20%',
            scaption: '15%',
            grip: '15%',
        },
        warning: {
            totalStrength: '< 50%',
            iR: '< 15%',
            eR: '< 15%',
            scaption: '< 10%',
            grip: '< 10%',
        }
    }
}
export const ShoulderBalance =
{
    title: 'Shoulder Balance',
    zones: {
        normal: {
            shoulderBalance: '0.85 - 1.05',
        },
        watch: {
            shoulderBalance: '0.70 - 0.84 & 1.06 - 1.20',
        },
        warning: {
            shoulderBalance: '< 0.70 & > 1.20',
        }
    }
}
export const StrengthVelocityRatio =
{
    title: 'Total Strength / Velo (Max.)',
    categories: ['Under 15', '15 & over'],
    zones: {
        normal: {
            under: '> 1.3',
            velocity: '> 1.60',
        },
        watch: {
            under: '1.1 to 1.3',
            velocity: '1.40 to 1.60',
        },
        warning: {
            under: '< 1.1',
            velocity: '< 1.40',
        }
    }
}